var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSugaring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff9494",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.538,24.438c-32.585-32.584-85.607-32.584-118.192,0c-9.2,9.2-335.66,335.66-344.87,344.87 c-32.586,32.585-32.586,85.607,0,118.193c32.66,32.662,85.527,32.667,118.192,0c17.991-17.991,333.438-333.437,344.87-344.87 C520.119,110.05,520.09,56.99,487.538,24.438z M392.983,48.077c19.551-19.55,51.363-19.551,70.916,0 c5.37,5.37,9.256,11.668,11.676,18.381H374.603L392.983,48.077z M119.029,463.864c-19.596,19.597-51.316,19.6-70.915,0 c-19.551-19.553-19.551-51.365,0.001-70.917l85.395-85.395l70.915,70.916L119.029,463.864z M228.063,354.829l-54.361-54.362 h108.722L228.063,354.829z M315.855,267.038H174.022l33.43-33.43h141.833L315.855,267.038z M382.715,200.178H240.882l33.43-33.43 h141.833L382.715,200.178z M449.575,133.318H307.742l33.43-33.43h134.663C471.248,113.254,464.284,118.608,449.575,133.318z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugaring);
export default __webpack_public_path__ + "static/media/sugaring.06ff1b7949d760256ae5b31cafb6fc44.svg";
export { ForwardRef as ReactComponent };